<template>
    <el-option
        v-bind="attrs"
        v-on="listeners"
    />
</template>

<script setup lang="ts">
import { Option as ElOption } from 'element-ui'
import { useAttrs, useListeners } from 'vue'

const attrs = useAttrs()
const listeners = useListeners()
</script>

